import { toLabeledValues } from 'components/CIMSSelect/utils/labeledValues'
import { User, Role } from '../../../../../../UsersTableContext/types'
import { EditUserFormValues } from './types'

export const tooltip = ({ permissions }: Role) =>
  `${permissions.length} Permissions`

export function getInitialValues(state?: User | null) {
  const values: EditUserFormValues = {
    admin: state && state.admin !== null ? true : undefined,
    permissionIds: state?.permissions ?? [],
    roles: toLabeledValues(state?.roles, {
      label: 'name',
      value: 'id',
      tooltip,
    }),
  }
  return values
}
